export const ThemeVariant = ['light', 'dark'];
export const NavPositionVariant = ['horizontal', 'vertical', 'combo', 'dual'];
export const NavTopShapeVariant = ['default', 'slim'];
export const NavbarAppearanceVariant = ['default', 'darker'];
export const Config = {
  isNavbarVerticalCollapsed: false,
  openNavbarVertical: false,
  theme: 'light',
  navbarVerticalAppearance: 'default',
  navbarTopAppearance: 'default',
  navbarPosition: 'vertical',
  navbarTopShape: 'default',
  isRTL: false
};

export const initialConfig = {
  isNavbarVerticalCollapsed: false,
  openNavbarVertical: false,
  theme: 'light',
  navbarVerticalAppearance: 'default',
  navbarTopAppearance: 'default',
  navbarPosition: 'vertical',
  navbarTopShape: 'default',
  isRTL: false
};
